import { LineChart } from '@mantine/charts';
import type { ComponentProps } from 'react';

const UNIFY_DEFAULTS = {
  gridAxis: 'x' as const,
  tickLine: 'xy' as const,
  gridProps: { yAxisId: 'left' as const },
};

export type UnifyLineChartProps = ComponentProps<typeof LineChart>;

export function UnifyLineChart(props: UnifyLineChartProps): JSX.Element {
  return <LineChart {...UNIFY_DEFAULTS} {...props} />;
}
